import { useParams } from 'react-router-dom'
import { useEffect } from 'react'
import "../styles/pages/our-services-public.styles.css"
export const OurServicesPublic = () => {
    const { servico } = useParams()
    useEffect(() => {
        const scrollToTop = () => {
          window.scrollTo({
            top: 0,
          })
        }
        scrollToTop()
    })
    return (
        <section className="our-services-public">
            <p>{servico}</p>
        </section>
    )
}